
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

import React from "react";
import {
	View,
} from "react-native";

import Style from "ae-style";
import PropTypes from "prop-types";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";

const styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		content: {
			paddingVertical: Style.layout.paddingList,
			flexDirection: "row",
			alignItems: "center",
			borderBottomColor: Style.colors.light,
			borderBottomWidth: 2
		},
		contrast: {
			borderBottomColor: Style.colors.secondary
		},
		margined: {
			paddingRight: Style.layout.paddingMedium / 4,
			paddingLeft: (Style.layout.paddingMedium + 2) / 4,
		},
		fold: {
			flexDirection: "column",
			alignItems: "flex-start"
		}
	},
	512: {
		content: {
			flexDirection: "row",
			paddingVertical: Style.layout.paddingSmall,
		},
		margined: {
			paddingRight: Style.layout.paddingMedium,
			paddingLeft: Style.layout.paddingMedium + 2,
		}
	}
});

export default function ListItem(props){
	const children = props.children;
	const contrast = props.contrast;
	const margined = props.margined;
	const fold = props.fold;
	const style = props.style;

	let styleList = [styles.content];

	if(style)
		styleList = styleList.concat(style);
	if(margined)
		styleList = styleList.concat(styles.margined);
	if(contrast)
		styleList = styleList.concat(styles.contrast);
	if(fold)
		styleList = styleList.concat(styles.fold);

	return (
		<View style={styleList}>
			{children}
		</View>
	);
}

ListItem.propTypes = {
	children: PropTypes.any,
	contrast: PropTypes.bool,
};
